<span class="w-100 text-secondary float-start text-truncate p-2" style="font-size: 12px;background:white !important;border: 1px solid #f1e9e9;">Date Range : <b>{{dateFrom}}</b> to <b>{{dateTo}}</b>
  <div [ngClass]="{'pointer-evt-none' : isAutoRefreshDisabled }" class="bg-info-box float-end refresh-info p-0 pointer" title="Click to refresh" (click)="onRefresh()">
    <span class="ps-2 pe-2 refresh-time"><i class="fa fa-refresh" [ngClass]="{'refresh-icon': isRefreshTime }"></i></span>
     <span id="#timer" class="pe-2">{{display}}</span>
    <span class="float-end refresh-label pi-2 pe-2" style="width: 260px;">
        <span>Last data refresh : {{refreshDate}}</span>
    </span>
  </div>
  <!-- 15:30 Min Last data refresh : 9/18/2020, 2:53:22 PM IST -->
</span>